module.exports = __webpack_public_path__ + "img/box-open.7a9dbf61.svg";